<template>
  <div class="platform-hub">
    <h2>Platform tools</h2>
    <p class="hub-description">
      Internal configuration for integrations, data connections, and platform operations.
    </p>

    <div class="tool-grid">
      <router-link to="/api-integrations" class="tool-card">
        <i class="fas fa-plug"></i>
        <div class="tool-body">
          <strong>API Integrations</strong>
          <span>GitHub, NCBI, PubMed, and external API connections</span>
        </div>
      </router-link>

      <router-link to="/database-connections" class="tool-card">
        <i class="fas fa-database"></i>
        <div class="tool-body">
          <strong>Database Connections</strong>
          <span>Warehouse and read-only SOR connections</span>
        </div>
      </router-link>

      <router-link to="/ab-testing" class="tool-card">
        <i class="fas fa-flask"></i>
        <div class="tool-body">
          <strong>A/B Testing</strong>
          <span>Experiment configuration and results</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountPlatformHub',
};
</script>

<style scoped>
.platform-hub {
  max-width: 720px;
}

.hub-description {
  color: #64748b;
  margin: 0 0 1.25rem;
  line-height: 1.5;
}

.tool-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.tool-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  text-decoration: none;
  color: inherit;
  transition: background 0.15s, border-color 0.15s;
}

.tool-card:hover {
  background: #f8fafc;
  border-color: #c5cae9;
}

.tool-card i {
  font-size: 1.25rem;
  color: #2c3e8c;
  margin-top: 0.15rem;
  width: 1.5rem;
  text-align: center;
}

.tool-body {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.tool-body strong {
  color: #1e293b;
}

.tool-body span {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.4;
}
</style>
